import { externalLogin } from 'services/authorization/authorization.service';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IExternalLoginPayload, ILoginResponse } from 'services/authorization/types';

export const ThunkExternalLogin = createAsyncThunk<ILoginResponse, IExternalLoginPayload>(
  'authorization/externalLogin',
  payload => externalLogin(payload).then(res => res.data),
);
